// Copyright 1999-2026. WebPros International GmbH. All rights reserved.

import { Button, Icon, useTranslate } from '@plesk/ui-library';
import { useContext } from 'react';
import { CopilotContext } from '../../CopilotContext';

const CopilotHeaderButton: React.FC = () => {
    const translate = useTranslate('components.copilot');
    const { setIsRightSidebarOpen, isRightSidebarOpen } = useContext(CopilotContext);

    const toggleOpen = (): void => {
        setIsRightSidebarOpen(!isRightSidebarOpen);
    };

    return (
        <Button
            tooltip={translate('header-button.tooltip')}
            id="copilot"
            ghost
            icon={<Icon src={require('images/AI.svg')} />}
            onClick={toggleOpen}
            aria-label={String(translate('header-button.aria-label'))}
        />
    );
};

export default CopilotHeaderButton;
